/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/**
 * Client-side session cleanup dùng chung cho logout() (chủ động) và
 * terminalLogout() (401 hết hạn).
 *
 * Tách khỏi new-auth-provider để terminalLogout xóa cookie ĐỒNG BỘ (không phụ
 * thuộc fetch('/api/auth/logout') async) — nếu không, reload sau logout có thể
 * còn cookie `token` → hydrate tưởng đã đăng nhập → gọi API → 401 → logout →
 * reload... (vòng lặp authen). Xóa client-side ngay đảm bảo reload = logged-out.
 */

/** Detect deployed ahafood domain (apex + subdomain) để xóa cookie Domain=.ahafood.ai. */
function isAhafoodDomain(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'ahafood.ai' || host.endsWith('.ahafood.ai');
}

/**
 * Xóa cookie auth client-side, mọi variant (host-only + apex domain). Đảm bảo
 * cookie bị xóa kể cả khi server Set-Cookie response bị browser drop do mismatch
 * SameSite/Secure.
 */
export function clearTokenCookiesClientSide() {
  if (typeof document === 'undefined') return;
  const names = ['token', 'refresh_token', 'auth_state', 'session_type'];
  const expire = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
  for (const name of names) {
    document.cookie = `${name}=; path=/; ${expire}`;
    if (isAhafoodDomain()) {
      document.cookie = `${name}=; path=/; domain=.ahafood.ai; ${expire}`;
    }
  }
}

/**
 * Xóa zustand persist storage của auth store. Tránh case sau hard nav, persist
 * middleware hydrate lại user cũ từ localStorage trước khi hydrateAndSync chạy.
 */
export function clearPersistedAuthStorage() {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem('ahafood.new-auth');
  } catch {
    /* ignore */
  }
}
